import { render } from "./HFruleadd.vue?vue&type=template&id=d6caf160&scoped=true"
import script from "./HFruleadd.vue?vue&type=script&lang=js"
export * from "./HFruleadd.vue?vue&type=script&lang=js"

import "./HFruleadd.vue?vue&type=style&index=0&id=d6caf160&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6caf160"]])

export default __exports__